
import { StringService } from '@nuskin/ns-util'

import TranslationService from '@/services/translation.js'

class NsLanguagePlugin {
    install (vue) {
        // Note 11/01/2019
        // The i18n plugin needs to be added to the translation service, however, it is not available
        // at this point. It needs to be added at the point the Vue instance is created. See
        // '@/main.js'.

        StringService.getApplicationStrings('loyalty').then((strings) => {
            TranslationService.setTranslations(strings)

            if ((typeof loyaltyAuthorConfig) === 'object') {
                // eslint-disable-next-line no-undef
                TranslationService.setTranslations(loyaltyAuthorConfig)
            }
        })

        Object.defineProperty(vue.prototype, '$nsLanguage', { value: this })
    }
}

export default
(function () {
    const NsLanguage = new NsLanguagePlugin()
    Object.assign(NsLanguage, TranslationService)

    return NsLanguage
})()
